import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function PageBanner({ title, crumb, subtitle, image = "/img/page-banner.jpg" }) {
  return (
    <section
      data-testid="page-banner"
      className="page-banner"
      style={{ backgroundImage: `url(${image})` }}
    >
      <div className="page-banner-overlay" />
      <div className="page-banner-inner glass-caption">
        <h1 className="font-serif page-banner-title">{title}</h1>
        <div className="page-banner-crumb">
          <Link to="/" style={{ color: "#FDE047", textDecoration: "none" }}>Home</Link>
          <ChevronRight size={14} />
          <span>{crumb || title}</span>
        </div>
        {subtitle && <p className="page-banner-sub">{subtitle}</p>}
      </div>
    </section>
  );
}

export function SectionTitle({ children, style }) {
  return (
    <div style={{ marginBottom: 22, ...style }}>
      <div className="sec-title">{children}</div>
      <div className="sec-underline" />
    </div>
  );
}
